@for (item of component.items; track $index) {
<href [link]="item.link">
    <div class="block link"
         [class.m-t-2]="!$first"
         [ngClass]="item.textStyle || ''"
         [style.color]="component?.textColor"
         [style.--active-text-color]="item?.activeTextColor || ''">
        <span *iCms="'text' of item; tag: item.tag;"></span>
    </div>
</href>
}